<template>
  <div>
    <q-tabs 
      v-model="nodeTab" 
      shrink stretch dense
      align="left">
      <div class="q-pl-sm q-pr-sm" style="background:#B2DFDB;color:#00695C;height:100%;display:flex;align-items:center;">
        <b>
          <q-icon name="sms" size="xs"/>
          <!-- 노드 -->
          {{$label('LBL0001004')}}
          </b>
      </div>
      <keep-alive
        v-for="(tab, idx) in tabItems"
        :key="idx" >
        <q-tab
          :name="tab.name"
          :label="tab.label"
          v-on:click="tabClick(tab)">
        </q-tab>
      </keep-alive>
    </q-tabs>
    <div class="row">
      <div class="col-12">
        <q-list bordered class="rounded-borders">
          <!-- 노드 정보 -->
          <q-expansion-item 
            dense dark default-opened
            icon="place" 
            header-class="bg-blue-grey-6 text-white"
            expand-icon-class="text-white"
            :label="$label('LBL0001195')" >
            <q-separator />
            <q-card class="q-pa-sm">
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-3">
                  <!-- 노드번호 -->
                  <c-label-text title="LBL0001090" :value="node.nodeNo"></c-label-text>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-3">
                  <!-- 노드 -->
                  <c-label-text title="LBL0001004" :value="node.nodeTitle"></c-label-text>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-4">
                  <!-- 검토기간 -->
                  <c-label-text title="LBL0001088" :value="node.startStudyDate + '~' + node.endStudyDate"></c-label-text>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-6 ">
                  <!-- 노드설명 -->
                  <c-label-text title="LBL0001085" :value="node.nodeDesc"></c-label-text>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6">
                  <!-- 설계조건 -->
                  <c-label-text title="LBL0001086" :value="node.designConditions"></c-label-text>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6">
                  <!-- 작동조건 -->
                  <c-label-text title="LBL0001087" :value="node.operatingConditions"></c-label-text>
                </div>
                  <!-- 설계의도 -->
                <div class="col-xs-12 col-sm-12 col-md-6">
                  <c-label-text title="LBL0001015" :value="node.designIntent"></c-label-text>
                </div>
              </div>
            </q-card>
          </q-expansion-item>
        </q-list>
      </div>
    </div>
    <!-- 시나리오 목록 -->
    <c-table
      ref="table"
      title="LBL0001165"
      :columns="grid.columns"
      :gridHeight="grid.height"
      :data="node.hazopScenarios"
      :merge="grid.merge"
      :filtering="false"
      :columnSetting="false"
      :usePaging="false"
      :editable="editable&&!disabled"
      :customTrClass="setTrClass"
      selection="multiple" 
      rowKey="ramHazopAssessScenarioId"
      @callbackProxy="callbackProxy"
      @innerBtnClicked="innerBtnClicked"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <!-- 이전평가결과조회 -->
          <c-btn 
            v-show="isCompared" 
            label="LBL0001166" 
            icon="compare_arrows" 
            @btnClicked="compareScenario" />
          <!-- 이탈추가 -->
          <c-btn v-if="editable&&!disabled" label="LBL0001196" icon="add" @btnClicked="addRiskType" />
          <!-- 삭제 -->
          <c-btn v-if="editable&&!disabled" label="LBLREMOVE" icon="remove" @btnClicked="removeScenario" />
          <c-btn 
            v-if="editable&&!disabled" 
            :isSubmit="isSave"
            :url="saveUrl"
            :param="node.hazopScenarios"
            mappingType="PUT"
            label="LBLSAVE" 
            icon="save"
            @beforeAction="saveScenario"
            @btnCallback="saveScenarioCallback" />
        </q-btn-group>
      </template>
      <template v-slot:customArea="{ props, col }">
        <template v-if="col.name==='customCol'">
          <component
            :is="imprComponent"
            :col="col"
            :props="props"
            :inputEditable="editable && !disabled && Boolean(props.row.ramHazopAssessScenarioId)"
            :requestContentsCols="requestContentsCols"
            tableKey="ramHazopAssessScenarioId"
            ibmTaskTypeCd="ITT0000001"
            ibmTaskUnderTypeCd="ITTU000001"
            @imprChange="imprChange"
          />
        </template>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
    <c-win-pop 
      ref="winPopup"  
      @onClose="val=>evtCloseWinPopup(val)"  
      @onRecvEvtFromWinPop="val=>onRecvWinPop(val)" />
  </div>
</template>

<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';

export default {
  name: 'hazop-scenario',

  props: {
    draw: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: '',  // 평가 일련번호
        processCd: '',  // 단위공정 코드
        processName: '',  // 단위공정 코드
        psiDiagramId: '',  // 도면 일련번호
        ramTechniqueCd: '',  // 평가기법 코드_HAZOP, K-PSR 구분(평가계획의 평가기법 코드 그대로 사용)
        diagramNo: '',  // 도면번호
        diagramTitle: '',  // 도면명
        nodes: [],
      }),
    },
    param: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: '',
        ramStepCd: '',
        ramTechniqueCd: '',
      }),
    },
    disabled: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    process: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: '',  // 평가 일련번호
        processCd: '',  // 단위공정 코드
        processName: '',  // 단위공정명
        ramProcessAssessStepCd: '',  // 평가진 ㅏ행상태
        processExplainFeature: '',  // 공정 특징 설명
        assessDeptCd: '',  // 평가 부서 코드
        assessUserId: '',  // 평가 담당자
        assessUserName: '',  // 평가 담당자
        ramMatrixId: '',
        draws: [],
        hazopScenarios: [],
        reCheckedCnt: 0,
      }),
    },
    updateBtnData: {
      type: Object,
      default: () => ({
        title: 'LBL0001164', // 평가
        flag: false,
        research: '',
      }),
    },
    planUpdateBtnData: {
      title: 'LBLPLAN', // 계획
      flag: false,
      research: '',
      planResearch: '',
    },
  },
  data() {
    return {
      nodeTab: '',
      node: {
        ramAssessNodeId: '',  // 노드 일련번호
        ramRiskAssessmentPlanId: '',  // 평가 일련번호
        ramTechniqueCd: '',  // 평가기법 코드_HAZOP, K-PSR 구분(평가계획의 평가기법 코드 그대로 사용)
        processCd: '',  // 단위공정 코드
        psiDiagramId: '',  // 도면 일련번호
        nodeNo: '',  // 노드 번호_수기입력
        nodeTitle: '',  // 노드 타이틀
        nodeDesc: '',  // 노드 설명
        designConditions: '',  // 설계조건
        operatingConditions: '',  // 작동조건
        designIntent: '',  // 설계의도
        startStudyDate: '',  // 검토 시작일
        endStudyDate: '',  // 검토 종료일
        hazopScenarios: [],
        ramMatrixId: '',
      },
      riskPopComponent: () => import(`${"@/pages/ram/base/matrixPop.vue"}`),
      grid: {
        merge: [
          { index: 0, colName: 'deviationName' },
        ],
        columns: [
          {
            fix: true,
            name: 'deviationName',
            field: 'deviationName',
            // 이탈
            label: 'LBL0001005',
            align: 'center',
            style: 'width:100px',
            innerBtn: true,
            btns: [
              { label: '', icon: 'add', color: 'light-blue', value: '1', tooltip: '가능한 원인 추가 <font color="#F0F4C3"><b>(※ 관리되는 항목)</b></font>' },
              { label: '', icon: 'add', color: 'orange', value: '2', tooltip: '원인 추가' },
            ],
            sortable: false,
          },
          {
            fix: true,
            name: 'nodeVariableDesignIntent',
            field: 'nodeVariableDesignIntent',
            // 설계의도
            label: 'LBL0001015',
            align: 'left',
            style: 'width:200px',
            type: 'text',
            sortable: false,
            required: true,
          },
          {
            name: 'riskOccurrenceCause',
            field: 'riskOccurrenceCause',
            // 원인
            label: 'LBL0001006',
            align: 'left',
            style: 'width:200px',
            type: 'text',
            sortable: false,
            required: true,
          },
          {
            name: 'riskOccurrenceResult',
            field: 'riskOccurrenceResult',
            // 결과
            label: 'LBL0001007',
            align: 'left',
            style: 'width:200px',
            type: 'text',
            sortable: false,
            required: true,
          },
          {
            name: 'relationLaw',
            field: 'relationLaw',
            // 관련법규
            label: 'LBL0001021',
            align: 'left',
            style: 'width:120px',
            type: 'text',
            sortable: false,
          },
          {
            name: 'currentSafetyMeasures',
            field: 'currentSafetyMeasures',
            // 현재안전조치
            label: 'LBL0001025',
            align: 'left',
            style: 'width:170px',
            type: 'text',
            sortable: false,
            required: true,
          },
          {
            name: 'before',
            field: 'before',
            // 개선전
            label: 'LBL0001008',
            align: 'center',
            child: [
              {
                name: 'beforeFrequency',
                field: 'beforeFrequency',
                // 빈도
                label: 'LBL0001009',
                align: 'center',
                style: 'width:40px',
                sortable: false
              },
              {
                name: 'beforeStrength',
                field: 'beforeStrength',
                // 강도
                label: 'LBL0001010',
                align: 'center',
                style: 'width:40px',
                sortable: false
              },
              {
                name: 'beforeRisk',
                field: 'beforeRisk',
                // 위험도
                label: 'LBL0001011',
                align: 'center',
                style: 'width:70px',
                sortable: false,
                type: 'proxy',
                component: this.riskPopComponent
              },
            ]
          },
          {
            name: 'after',
            field: 'after',
            // 개선후
            label: 'LBL0001012',
            align: 'center',
            child: [
              {
                name: 'afterFrequency',
                field: 'afterFrequency',
                // 빈도
                label: 'LBL0001009',
                align: 'center',
                style: 'width:40px',
                sortable: false
              },
              {
                name: 'afterStrength',
                field: 'afterStrength',
                // 강도
                label: 'LBL0001010',
                align: 'center',
                style: 'width:40px',
                sortable: false
              },
              {
                name: 'afterRisk',
                field: 'afterRisk',
                // 위험도
                label: 'LBL0001011',
                align: 'center',
                style: 'width:70px',
                sortable: false,
                required: true,
                type: 'proxy',
                component: this.riskPopComponent
              },
            ]
          },
          {
            name: 'assessDate',
            field: 'assessDate',
            // 평가일
            label: 'LBL0001013',
            align: 'center',
            type: 'date',
            style: 'width:130px',
            sortable: false,
            required: true,
          },
          {
            name: 'assessUserName',
            field: 'assessUserName',
            // 평가자
            label: 'LBL0001014',
            align: 'center',
            type: 'user',
            userId: 'assessUserId',
            style: 'width:80px',
            sortable: false,
            required: true,
          },
          {
            name: 'riskbookFlag',
            field: 'riskbookFlag',
            // 위험등록부
            label: 'LBL0001171',
            align: 'center',
            style: 'width:90px',
            sortable: true,
            type: 'check',
            'true': 'Y',
            'false': 'N',
            disableTarget: 'riskRegisterFlag',
            disableCon: false
          },
          {
            name: 'impr',
            field: 'impr',
            // 개선진행
            label: 'LBL0001178',
            align: 'center',
            child: [
              {
                name: 'customCol',
                field: 'customCol',
                label: 'LBLIMPRNO_PROGRESS',
                align: 'center',
                style: 'width:150px',
                type: 'custom',
                sortable: false
              },
              {
                name: 'improvementMeasures',
                field: 'improvementMeasures',
                // 개선대책
                label: 'LBL0001408',
                align: 'left',
                style: 'width:200px',
                type: 'text',
                sortable: false
              },
            ]
          },
        ],
        data: [],
        height: '550px'
      },
      // scenario: {
      //   ramHazopAssessScenarioId: '',  // 시나리오 일련번호
      //   ramRiskAssessmentPlanId: '',  // 평가 일련번호
      //   processCd: '',  // 단위공정 코드
      //   processName: '',  // 단위공정
      //   ramAssessNodeId: '',
      //   ramVariableGuidewordId: '',
      //   nodeVariableDesignIntent:'',
      //   deviationName:'',
      //   riskOccurrenceCause: '',
      //   riskOccurrenceResult: '',
      //   relationLaw: '',
      //   currentSafetyMeasures: '',
      //   beforeRamMatrixRiskId: '',  // 전 위험도 no
      //   afterRamMatrixRiskId: '',  // 후 위험도 no
      //   improvementMeasures: '',
      //   existingRiskManagementActivities: '',  // 현재안전조치
      //   assessDate: '',  // 평가일
      //   assessUserId: '',  // 평가자 ID
      //   assessUserName: '',  // 평가자명
      //   recheckFlag: '',
      //   regUserId: '',  // 작성자 ID
      //   chgUserId: '',  // 수정자 ID
      //   imprs: [], // 개선목록
      // },
      imprComponent: () => import(`${'@/pages/common/ibm/tableImpr.vue'}`),
      activeWinProps: {
        processCd: '',
        ramHazopAssessScenarioId: '',
      },
      guideWordItems: [],
      requestImprRow: null,
      imprData: null,
      rowIndex: 0,
      editable: true,
      isSave: false,
      listUrl: '',
      saveUrl: '',
      deleteUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '80%',
        param: {},
        closeCallback: null,
      },

    };
  },
  computed: {
    isCompared() {
      return this.process.reCheckedCnt > 0;
    },
    tabItems() {
      let data = [];
      this.$_.forEach(this.draw.nodes, node => {
        data.push({
          name: node.ramAssessNodeId,
          label: node.nodeTitle + ' (' + node.nodeNo + ')',
          node: node,
        })
      })
      return data;
    },
    requestContentsCols() {
      return ['deviationName', 'nodeVariableDesignIntent'];
    },
  },
  watch: {
    'updateBtnData.research'() {
      this.getList();
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
    window.addEventListener('beforeunload', () => {
      this.$refs.winPopup.closeWinPop()
    });
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    this.$refs.winPopup.closeWinPop()
    window.removeEventListener('beforeunload', () => {
      this.$refs.winPopup.closeWinPop()
    });
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.ram.hazop.scenario.list.url
      this.saveUrl = transactionConfig.ram.hazop.scenario.save.url
      this.deleteUrl = transactionConfig.ram.hazop.scenario.delete.url
      // code setting
      this.$comm.getComboItems('RAM_VARIABLE_GUIDEWORD_CD').then(_result => {
        this.guideWordItems = _result
      });
      // list setting
      this.nodeTab = this.draw.nodes[0].ramAssessNodeId
      this.tabClick({ node: this.draw.nodes[0] })

    },
    
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        ramAssessNodeId: this.node.ramAssessNodeId,
      }
      this.$http.request((_result) => {
        this.node.hazopScenarios = _result.data;
        let idx = this.$_.findIndex(this.draw.nodes, { ramAssessNodeId: this.node.ramAssessNodeId });
        this.$set(this.draw.nodes[idx], 'hazopScenarios', _result.data)
      },);

      // if (count > 0) {
      //   this.recheckCountFlag = true;
      // } else {
      //   this.recheckCountFlag = false;
      // }
    },
    research() {
      this.$emit('research');
    },
    tabClick(tab) {
      this.$_.extend(this.node, tab.node)
    },
    imprChange() {
      this.$refs['table'].$refs['compo-table'].resetVirtualScroll();
      this.research();
    },
    /* eslint-disable no-unused-vars */
    innerBtnClicked(col, props, btn) {
      if (col.name === 'deviationName') {
        if (btn.value === '1') {
          this.rowIndex = props.rowIndex;
          this.popupOptions.title = 'LBL0001197'; // 가능한 원인
          this.popupOptions.param = {
            ramVariableId: props.row.ramVariableId,
            ramVariableGuidewordCd: props.row.ramVariableGuidewordCd,
            deviationName: props.row.deviationName,
          };
          this.popupOptions.target = () => import(`${'@/pages/ram/base/hazopCausePop.vue'}`);
          this.popupOptions.width = '45%';
          this.popupOptions.visible = true;
          this.popupOptions.closeCallback = this.closeCausePopup;
        } else {
          this.node.hazopScenarios.splice(props.rowIndex, 0, {
            ramHazopAssessScenarioId: uid(),
            ramAssessNodeId: this.node.ramAssessNodeId,
            ramVariableGuidewordId: props.row.ramVariableGuidewordId, 
            ramVariableId: props.row.ramVariableId,
            ramVariableGuidewordCd: props.row.ramVariableGuidewordCd,
            deviationName: props.row.deviationName, 
            nodeVariableDesignIntent: '', 
            riskOccurrenceCause: '', 
            riskOccurrenceResult: '',
            currentSafetyMeasures: '', 
            beforeRamMatrixRiskId: '',  // 전 위험도 no
            afterRamMatrixRiskId: '',  // 후 위험도 no
            improvementMeasures: '',  // 개선대책_개선요청과 별개로 수기 입력
            assessDate: this.$comm.getToday(),
            assessUserName: this.$_.clone(this.process.assessUserName),
            assessUserId: this.$_.clone(this.process.assessUserId),
            riskbookFlag: 'N', 
            sopImprovementIds: '', 
            ibmStepNames: '', 
            editFlag: 'C',
            ramMatrixId: this.node.ramMatrixId,
            // 위험등록부 등재를 위한 prop
            ramRiskAssessmentPlanId: this.node.ramRiskAssessmentPlanId,
            processCd: this.node.processCd,
            riskRegisterFlag: false,
          });
        }
      }
    },
    closeCausePopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;

      if (data && data.length > 0) {
        this.$_.forEach(data, item => {
          this.node.hazopScenarios.splice(this.rowIndex, 0, {
            ramHazopAssessScenarioId: uid(),
            ramAssessNodeId: this.node.ramAssessNodeId,
            ramVariableId: item.ramVariableId,
            ramVariableGuidewordCd: item.ramVariableGuidewordCd,
            ramVariableGuidewordId: item.ramVariableGuidewordId, 
            deviationName: item.deviationName, 
            nodeVariableDesignIntent: '', 
            riskOccurrenceCause: item.causeName, 
            riskOccurrenceResult: '',
            currentSafetyMeasures: '', 
            beforeRamMatrixRiskId: '',  // 전 위험도 no
            afterRamMatrixRiskId: '',  // 후 위험도 no
            improvementMeasures: '',  // 개선대책_개선요청과 별개로 수기 입력
            assessDate: this.$comm.getToday(),
            assessUserName: this.$_.clone(this.process.assessUserName),
            assessUserId: this.$_.clone(this.process.assessUserId),
            riskbookFlag: 'N', 
            sopImprovementIds: '', 
            ibmStepNames: '', 
            editFlag: 'C',
            ramMatrixId: this.node.ramMatrixId,
            // 위험등록부 등재를 위한 prop
            ramRiskAssessmentPlanId: this.node.ramRiskAssessmentPlanId,
            processCd: this.node.processCd,
            riskRegisterFlag: false,
          });
        });
      }
    },
    /* eslint-disable no-unused-vars */
    callbackProxy(data, props, col) {
      if (col.name === 'beforeRisk') {
        this.$set(this.node.hazopScenarios[props.rowIndex], 'beforeFrequency', data.f)
        this.$set(this.node.hazopScenarios[props.rowIndex], 'beforeStrength', data.s)
        this.$set(this.node.hazopScenarios[props.rowIndex], 'beforeRisk', data.r)
        this.$set(this.node.hazopScenarios[props.rowIndex], 'beforeRamMatrixRiskId', data.ramMatrixRiskId)
      } else {
        this.$set(this.node.hazopScenarios[props.rowIndex], 'afterFrequency', data.f)
        this.$set(this.node.hazopScenarios[props.rowIndex], 'afterStrength', data.s)
        this.$set(this.node.hazopScenarios[props.rowIndex], 'afterRisk', data.r)
        this.$set(this.node.hazopScenarios[props.rowIndex], 'afterRamMatrixRiskId', data.ramMatrixRiskId)
      }
      if (this.node.hazopScenarios[props.rowIndex].editFlag !== 'C') {
        this.$set(this.node.hazopScenarios[props.rowIndex], 'editFlag', 'U')
      }
    },
    addRiskType() {
      this.popupOptions.title = 'LBL0001198'; // 가이드워드
      this.popupOptions.param = {
        guideWordItems: this.guideWordItems,
        data: this.node.hazopScenarios,
        node: this.node,
        ramRiskAssessmentPlanId: this.param.ramRiskAssessmentPlanId,
        type: 'multiple',
      };
      this.popupOptions.target = () => import(`${'@/pages/ram/base/hazopGuidewordPop.vue'}`);
      this.popupOptions.width = '80%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeRiskTypePopup;
    },
    closeRiskTypePopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;

      if (data && data.length > 0) {
        this.$_.forEach(data, item => {
          this.$_.forEach(this.guideWordItems, gw => {
            let name = item.variableName + ' - ' + gw.codeName;
            let index = this.$_.findIndex(this.node.hazopScenarios, { deviationName: name });
            if (item[gw.code] === 'Y' && index === -1) {
              this.node.hazopScenarios.splice(0, 0, {
                ramHazopAssessScenarioId: uid(),
                ramAssessNodeId: this.node.ramAssessNodeId,
                ramVariableId: item.ramVariableId,
                ramVariableGuidewordCd: gw.code,
                ramVariableGuidewordId: item[gw.code + '_id'], 
                deviationName: name, 
                nodeVariableDesignIntent: '', 
                riskOccurrenceCause: '', 
                riskOccurrenceResult: '',
                currentSafetyMeasures: '', 
                beforeRamMatrixRiskId: '',  // 전 위험도 no
                afterRamMatrixRiskId: '',  // 후 위험도 no
                improvementMeasures: '',  // 개선대책_개선요청과 별개로 수기 입력
                assessDate: this.$comm.getToday(),
                assessUserName: this.$_.clone(this.process.assessUserName),
                assessUserId: this.$_.clone(this.process.assessUserId),
                riskbookFlag: 'N', 
                sopImprovementIds: '', 
                ibmStepNames: '', 
                editFlag: 'C',
                ramMatrixId: this.node.ramMatrixId,
                // 위험등록부 등재를 위한 prop
                ramRiskAssessmentPlanId: this.node.ramRiskAssessmentPlanId,
                processCd: this.node.processCd,
                riskRegisterFlag: false,
              });
            } else if (item[gw.code] === 'N' && index > -1) {
              this.node.hazopScenarios = this.$_.reject(this.node.hazopScenarios, { deviationName: name })
            }
          })
        });
        let checkLists = [];
        this.$_.forEach(this.guideWordItems, gw => {
          let filterData = this.$_.filter(data, (item) => {
            return item[gw.code] === 'Y'
          });
          this.$_.forEach(filterData, fd => {
            checkLists.push(fd.variableName + ' - ' + gw.codeName)
          })
        });
        let deleteLists = [];
        this.$_.forEach(this.node.hazopScenarios, gridItem => {
          let index = this.$_.indexOf(checkLists, gridItem.deviationName);
          if (index === -1) {
            deleteLists.push(gridItem.deviationName)
          }
        });
        if (deleteLists && deleteLists.length > 0) {
          this.$_.forEach(deleteLists, deleteItem => {
            this.node.hazopScenarios = this.$_.reject(this.node.hazopScenarios, { deviationName: deleteItem })
          })
        }
      }
    },
    saveScenario() {
      if (this.$comm.validTable(this.grid.columns, this.node.hazopScenarios)) {
        window.getApp.$emit('CONFIRM', {
          title: 'LBLCONFIRM',
          message: 'MSGSAVE', // 저장하시겠습니까?
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$_.forEach(this.node.hazopScenarios, item => {
              item.regUserId = this.$store.getters.user.userId
              item.chgUserId = this.$store.getters.user.userId
            })
            
            this.isSave = !this.isSave
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    saveScenarioCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.research();
      this.getList();
    },
    removeScenario() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: 'MSGNOITEMS', // 선택된 항목이 없습니다.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: 'LBLCONFIRM',
          message: 'MSGREMOVE', // 삭제하시겠습니까?,
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.deleteUrl;
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData),
            };
            this.$http.request(() => {
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              this.$_.forEach(selectData, item => {
                this.node.hazopScenarios.splice(this.$_.findIndex(this.node.hazopScenarios, item), 1)
              })
              this.$refs['table'].$refs['compo-table'].clearSelection();

              this.planUpdateBtnData.planResearch = uid();
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    compareScenario() {
      let uri = `/ram/compare/compareScenario?ramTechniqueCd=${this.param.ramTechniqueCd}&ramRiskAssessmentPlanId=${this.param.ramRiskAssessmentPlanId}&processCd=${this.process.processCd}&psiDiagramId=${this.node.psiDiagramId}&nodeNo=${this.node.nodeNo}`;
      this.$refs.winPopup.openWinPop(uri, 1560, 700);
    },
    evtCloseWinPopup() {
      Object.assign(this.$data.activeWinProps, this.$options.data().activeWinProps);
    },
    onRecvWinPop(recvObj) {
      if(recvObj) {
        this.$set(this.activeWinProps, 'processCd', recvObj.processCd)
        this.$set(this.activeWinProps, 'ramHazopAssessScenarioId', recvObj.ramHazopAssessScenarioId)
      }
    },
    setTrClass(props) {
      return props.row.processCd === this.activeWinProps.processCd 
        && props.row.compareId === this.activeWinProps.ramHazopAssessScenarioId ? 'bg-purple-2' : '';
    },
  }
};
</script>
<style lang="sass">
.scenario-chip i 
  margin-right: -0.2em !important
</style>